import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#0a0f1e] pt-20 pb-32 md:pt-32 md:pb-48" data-id="element-40">
      {/* Background Gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-41">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#25D366] opacity-10 blur-[100px] rounded-full" data-id="element-42" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-600 opacity-10 blur-[120px] rounded-full" data-id="element-43" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-44">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-45">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366]/10 border border-[#25D366]/20 text-[#25D366] font-medium text-sm mb-8" data-id="element-46">
            <span className="relative flex h-2 w-2" data-id="element-47">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75" data-id="element-48"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#25D366]" data-id="element-49"></span>
            </span>
            EL ARQUITECTO DE AGENDAS
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight mb-6" data-id="element-50">
            Instala tu propio <br data-id="element-51" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#25D366] to-emerald-400" data-id="element-52">
              "Recepcionista de WhatsApp"
            </span>
            <br data-id="element-53" /> en menos de 15 minutos
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl leading-relaxed" data-id="element-54">
            La guía visual definitiva paso-a-paso que elimina las citas
            canceladas y automatiza tu negocio de servicios mientras duermes.{' '}
            <span className="text-[#25D366] font-semibold" data-id="element-55">
              Sin escribir código.
            </span>
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4 w-full justify-center mb-16" data-id="element-56">
            <Button size="lg" className="text-lg px-8 py-6 group" onClick={() => document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-57">
              QUIERO MI GUÍA AHORA
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-58" />
            </Button>
            <p className="text-sm text-slate-400 mt-4 sm:mt-0 sm:self-center" data-id="element-59">
              *Oferta por tiempo limitado: $59 USD
            </p>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 40
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.4
        }} className="relative w-full max-w-5xl mx-auto" data-id="element-60">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#25D366] to-blue-600 rounded-2xl blur opacity-20" data-id="element-61"></div>
            <img src="https://cdn.magicpatterns.com/uploads/scXj5WWNeHg87UDLicLSnE/CHATBOT_IMAGE.png" alt="Chatbot Agenda Total Dashboard" className="relative rounded-2xl shadow-2xl border border-slate-800 bg-[#0a0f1e]" data-id="element-62" />
          </motion.div>

          {/* Trust Indicators */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="mt-16 flex flex-wrap justify-center gap-8 text-slate-400 text-sm font-medium" data-id="element-63">
            <div className="flex items-center gap-2" data-id="element-64">
              <CheckCircle2 className="h-5 w-5 text-[#25D366]" data-id="element-65" />
              <span data-id="element-66">Sin mensualidades</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-67">
              <CheckCircle2 className="h-5 w-5 text-[#25D366]" data-id="element-68" />
              <span data-id="element-69">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-70">
              <CheckCircle2 className="h-5 w-5 text-[#25D366]" data-id="element-71" />
              <span data-id="element-72">Garantía de satisfacción</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}